(function VideoCall($, Adzuki)
{
	"use strict";

	$(document).ready(function onReady()
	{
		Adzuki.onload('LivePlanner/videoCall', function onload() {
			var group_session = parseInt($('#lp_group_session').val());

			Cookies.set('lp_confirm_video_close', 1);

			// the client joins the meeting
			setTimeout(function _joinMeeting() {
				$('.liveplanner-video-loader').remove();

				if (group_session) {
					Adzuki.LPVideo.joinZoomGroupMeeting();
				} else {
					Adzuki.LPVideo.joinZoomPeerMeeting();
				}
			}, 3000);

			// confirm before closing the window
			$(window).on('beforeunload', function _onBeforeUnload(e) {
				var confirm = Cookies.get('lp_confirm_video_close') || 1;

				if (parseInt(confirm)) {
					e.preventDefault();

					return 'Closing this window will end the current meeting. Are you sure you want to continue?';
				}
			});

			// leave the meeting if the window is closed
			$(window).on('pagehide', function _onPageHide(e) {
				Adzuki.LPVideo.leaveMeeting();
			});
		});

		Adzuki.onload('LivePlanner/videoEnded', function onload() {
			window.close();

			// fallback for closing the video window
			$('.lp-close-video-window').on('click', function _onClick(e) {
				e.preventDefault();

				window.close();
			});
		});
	});
}(jQuery, window.Adzuki || {}));
